import React , { useState, useEffect, useRef } from 'react';
import jwt_decode from 'jwt-decode';
import budgetsection from '../images/common/budget.png';
import adminsection from '../images/common/settings.png';
import menu from '../images/common/menu.png';
import icon from '../images/common/icon.png';
import help from '../images/common/help-blue.png';
import account from '../images/common/account.png';

import img_menu_arrows from '../images/common/arrows.png';
import img_menu_budget from '../images/common/budget.svg';
import img_menu_report from '../images/common/report.svg';
import img_brand from '../images/common/brand.png'

import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../css/Report.css';
import { Router, Switch, Route, Link } from "react-router-dom";
import history from "../Components/history";
import ReportList from "../Components/budget_components/ReportList";
import ViewReportGrid from "../Components/budget_components/ViewReportGrid";
import MenuPopup from '../Components/admin_components/pages/customComponents/MenuPopup';


const appName = "";///ArchicubedWeb //Production
//const appName = "/"; Development
const LoadBudgetMenu = (section) =>{
    history.push(appName + (section != '' ? '/'+section : '')) ;
}
const LoadSection = (section) =>{
    history.push(appName + (section != '' ? '/'+section : '')) ;
}

//ArchicubedWeb
// const heightSet = document.body.scrollHeight - margin;
function ReportPage() {
    if(localStorage.getItem("token") == null){   
        history.push('/login') ;
    }
    const [show,setShow]=useState(false);
    const decoded = jwt_decode(localStorage.getItem('token'));
    
    const [showBudget,setShowBudget] = useState(decoded.can_access_budget_list == "true");    
    const [showReport,setShowReport] = useState(decoded.can_create_reports == "true");
    const [showAgency,setShowAgency] = useState(decoded.can_manage_agency == "true");
    const [showAgencyFees,setShowAgencyFees] = useState(decoded.can_manage_agency_fees === "true");
    const [showAgencyNetwork,setShowAgencyNetwork] = useState(decoded.can_manage_agency_network === "true");
    
    const [showCountry,setShowCountry] = useState(decoded.can_manage_country === "true");
    const [showZone,setShowZone] = useState(decoded.can_manage_zone === "true");
    const [showSubzone,setShowSubzone] = useState(decoded.can_manage_subzone === "true");
    const [showMaison,setShowMaison] = useState(decoded.can_manage_maisons === "true");

    const [showPublisher,setShowPublisher] = useState(decoded.can_manage_publishers_vendors === "true");
    const [showAirport,setShowAirport] = useState(decoded.can_manage_airport_names === "true");
    const [showVehicle,setShowVehicle] = useState(decoded.can_manage_vehicles === "true");
    const [showPosition,setShowPosition] = useState(decoded.can_manage_positions === "true");
    
    const [showExchangeRate,setShowExchangeRate] = useState(decoded.can_manage_exchange_rate === "true");
    
    
    const [showUser,setShowUser] = useState(decoded.can_manage_users == "true");
    const [showProfile,setShowProfile] = useState(decoded.can_manage_profiles === "true");
    const [showRole,setShowRole] = useState(decoded.can_manage_roles === "true");
    
    const showAdmin  = showAgency 
                         || showAgencyFees
                         || showAgencyNetwork
                         || showCountry
                         || showZone
                         || showSubzone
                         || showMaison
                         || showPublisher
                         || showAirport
                         || showVehicle
                         || showPosition
                         || showExchangeRate
                         || showUser
                         || showProfile
                         || showRole;

    if(!showReport && showBudget){
        history.push('/budget') ;
    }
    const refMenuPopup = useRef();

    const ToggleMenuSection = () =>{
        setShow(! show); 
    };

    const componentRef1 = useRef();
    const componentRef2 = useRef();

    const colExpMenu = () =>{
        if(document.getElementById("lblMenu").style.display != "none"){
            document.getElementById("MenuSidebar").style.width = "50px";
            document.getElementById("lblMenu").style.display = "none";
            document.getElementById("lblBudget").style.display = "none";
            document.getElementById("lblReport").style.display = "none";
            document.getElementById("imgArrow").style.transform = "rotate(0.5turn)";
        }else{
             document.getElementById("MenuSidebar").style.width = "20%";
            document.getElementById("lblMenu").style.display = "block";
            document.getElementById("lblBudget").style.display = "block";
            document.getElementById("lblReport").style.display = "block";
            document.getElementById("imgArrow").style.transform = "rotate(0turn)";
        }
    }

    useEffect(() => {
        document.addEventListener("click", handleClick);
        return () => document.removeEventListener("click", handleClick);
        function handleClick(e) {
            if(componentRef1 && componentRef1.current){
                const ref1 = componentRef1.current
                const ref2 = componentRef2.current
                const ref3 = refMenuPopup.current.componentRef.current
                if(!ref1.contains(e.target) && !ref2.contains(e.target) && !ref3.contains(e.target)){
                    refMenuPopup.current.setShowUser(false); 
                    refMenuPopup.current.setshowHelp(false);
                }
            }
        }
    }, []);

    return (<Router  history={history} basename="/">
        {/* <SelectProfile></SelectProfile> */}
      <div className="App">
        
        <div className="div-header">
        <div  className="div-header-menu" style={{cursor:'pointer'}} onClick={() => ToggleMenuSection()} >
                <img src={menu} style={{ marginTop: "-5px"}} onClick={() => ToggleMenuSection()}></img>
            </div>
            <div className="div-header-info" >                
                <img alt=''  className='imgBRAND' src={img_brand}></img>
                <label className="lbl-header-info">Data & Budget Tool</label>
             </div>
             <div className="div-header-help push" style={{cursor:'pointer'}} ref={componentRef1}>
                <img src={help} onClick={() => refMenuPopup.current.ToggleMenuSectionHelp()}></img>
            </div>
            <div className="div-header-account" style={{cursor:'pointer'}} ref={componentRef2}>
                <img src={account} onClick={() => refMenuPopup.current.ToggleMenuSectionUser()}></img>
            </div>
          </div>

          <div className="div-body">
            <div className={show ? "div-menu-sections " + (!showAdmin ? " div-menu-sections-half" : ' ') : "div-menu-sections hidden"}>
            <div className={!showAdmin ? "fullwidth div-menu-sections_details div-menu-sections_budget" : "div-menu-sections_details div-menu-sections_budget"} onClick={() => LoadSection('budget')} >
                        <img src={budgetsection}></img>
                        <label>Data & Budget Tool</label>
                </div>
                <div className={showAdmin ? "div-menu-sections_details div-menu-sections_admin" : "hidden div-menu-sections_details div-menu-sections_admin" } onClick={() => LoadSection('admin')} >
                    <img src={adminsection}></img>
                    <label>Administration Center</label>
                </div>

            </div>
          {/* <div className="div-body">
            <div className={show ? "div-menu-sections" : "div-menu-sections hidden" }  >
                <div className="div-menu-sections_details div-menu-sections_budget" onClick={() => LoadSection('budget')} >
                        <img src={budgetsection}></img>
                        <label>Data & Budget Tool</label>
                </div>
                <div className="div-menu-sections_details div-menu-sections_admin" onClick={() => LoadSection('admin')} >
                    <img src={adminsection}></img>
                    <label>Administration Center</label>
                </div>

            </div> */}

            <MenuPopup ref={refMenuPopup} />

            <div id='MenuSidebar' className="div-body-menu" style={{width: '20%'}}>
            <div className="div-menu-quickaccess">              
             <div class="div-menu-details" style={{cursor:'pointer'}}>
                    <label id='lblMenu' style={{cursor:'pointer', display:'block', paddingLeft: '20px'}}>Menu</label>
                </div> 
                <div class="div-menu-quickaccess-img push">
                <img onClick={() => colExpMenu()} id='imgArrow' style={{height: '38px', marginRight: '10px'}} src={img_menu_arrows}></img>
                </div>               
            </div>
            <div className={showBudget ? "div-menu-li" : "div-menu-li hidden" }  onClick={() => LoadBudgetMenu('budget') } >
                <div class="div-menu-img">
                <img src={img_menu_budget}></img>
                </div>
                <div class="div-menu-details">
                    <label id='lblBudget' style={{cursor: 'pointer', display:'block'}}>Budget List</label>
                </div>                
            </div>
            <div className={showReport ? "div-menu-li" : "div-menu-li hidden" }  onClick={() => LoadBudgetMenu('report') } >
                <div class="div-menu-img">
                <img src={img_menu_report}></img>
                </div>
                <div class="div-menu-details">
                    <label id='lblReport' style={{cursor: 'pointer', display:'block', marginTop: '2px'}}>Reports</label>
                </div>                
            </div>
          </div>
          <div className="div-body-details">
          <div>
              <Switch>
              <Route exact path={appName+'/report'} component={ReportList} />
              <Route exact path={appName+'/report/reportView'} component={ViewReportGrid} />
            </Switch>
          </div>
            </div>
        </div>  
        </div>
       </Router>
    );
}

export default ReportPage;
